import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";

const urlBase = `${config.urlApi}/Mensalidades`;

const urls = {
  obter: `${urlBase}`,
  alterar: `${urlBase}`,
  pagar: `${urlBase}`,
}

function getToken(): string {

  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);

    if (user && user.accessToken) {
      return `Bearer  ${user.accessToken}`;
    } else {
      return "";
    }
  }
  else
    return "";
}

export const obterPorContrato = (contratoId: number): Promise<Mensalidade[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obter, { params: { contratoId } })
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter parcelas")));
  });
};

export const alterar = (id: number, model: MensalidadeAlterarDto): Promise<Mensalidade> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .put(`${urls.alterar}/${id}`, model)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao alterar parcela")));
  });
};

export const pagar = (id: number): Promise<Mensalidade> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(`${urls.pagar}/${id}/Pagar`)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao registrar pagamento")));
  });
};

export interface Mensalidade {
  id: number;
  contratoId: number | null;
  parcela: number;
  referente: string | null;
  statusId: number | null;
  dataVencimento: string | null;
  dataPagamento: string | null;
  valor: number;
  valorPago: number;
  boletoId: number | null;
}

export interface MensalidadeAlterarDto {
  dataVencimento: string | null;
  valor: number;
  referente: string | null;
}
